// ─────────────────────────────────────────────────────────────────────────
// Crisis Advisor — frontend API client.
// Stateless: the page keeps the conversation in memory and sends the full
// history each turn. Backend invokes Bedrock InvokeModel (Claude 3.5
// Sonnet) with the system prompt from src/prompts/crisisAdvisor.ts.
// ─────────────────────────────────────────────────────────────────────────

import { API_BASE, getApiHeaders } from './apiClient';

export interface AdvisorMessage {
  role:       'user' | 'assistant';
  content:    string;
  timestamp?: string;
}

export interface AdvisorSuggestion {
  label:  string;
  prompt: string;
}

export interface AdvisorGreetingResponse {
  greeting:    string;
  suggestions: AdvisorSuggestion[];
}

async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const res  = await fetch(`${API_BASE}${path}`, {
    headers: { ...getApiHeaders(), ...options?.headers },
    ...options,
  });
  const text = await res.text();
  let data: any;
  try { data = JSON.parse(text); } catch { throw new Error(`Server error ${res.status}`); }
  if (!res.ok) throw new Error(data.error || `Request failed: ${res.status}`);
  return data as T;
}

export async function getAdvisorGreeting(): Promise<AdvisorGreetingResponse> {
  return apiFetch<AdvisorGreetingResponse>('/cima/advisor/greeting');
}

export async function sendAdvisorMessage(messages: AdvisorMessage[]): Promise<{ message: AdvisorMessage }> {
  return apiFetch<{ message: AdvisorMessage }>(
    '/cima/advisor',
    { method: 'POST', body: JSON.stringify({ messages }) },
  );
}
